import { useGetDomainsList, useGetSourcesList } from "./treetransferservice";

export { useGetSourcesList, useGetDomainsList };
